














import {Component, Prop, Vue} from "vue-property-decorator";
    import { EventBus } from "@/helpers/EventBus";
    import { OrdersList } from "@/model/OrdersList";
    import { TabType } from "@/model/TabType";
    import Tab from "@/components/Tab.vue";
    import TabBody from "@/components/TabBody.vue";
    import { DisplayMode } from "./ItemsListDashboard.vue";
    import { OrderedProductsList } from "@/model/OrderedProductsList";

    @Component({
      components: {Tab, TabBody}
    })
    export default class TabsContainer extends Vue {

      @Prop({default: false}) public canHandleSupports: boolean;
      
      private activeTab: TabType = TabType.TO_PROCESS;
      private activeDisplay: DisplayMode = DisplayMode.ORDERS;

      private nbOrdersToProcess: number = 0;
      private nbOrdersProcessed: number = 0;
      private nbProductsToProcess: number = 0;
      private nbProductsProcessed: number = 0;
      private resetMissingFilterKey: number = 0;

      created() {
        EventBus.$on(EventBus.REFRESH_ORDERS_LIST, this.onRefreshOrdersList);
        EventBus.$on(EventBus.REFRESH_ORDERED_PRODUCTS_LIST, this.onRefreshOrderedProductsList);
        EventBus.$on(EventBus.TOGGLE_DISPLAY, this.onToggleDisplay)
      }

      beforeDestroy() {
        EventBus.$off(EventBus.REFRESH_ORDERS_LIST, this.onRefreshOrdersList);
        EventBus.$off(EventBus.REFRESH_ORDERED_PRODUCTS_LIST, this.onRefreshOrderedProductsList);
        EventBus.$off(EventBus.TOGGLE_DISPLAY, this.onToggleDisplay);
      }

      setActiveTab(tab: TabType) {
        this.activeTab = tab;
        this.resetMissingFilterKey++;
      }

      private onRefreshOrdersList(data: OrdersList) {
        this.updateOrdersCount(data);
      }

      private onRefreshOrderedProductsList(data: OrderedProductsList) {
        this.updateProductsCount(data);
      }

      private onToggleDisplay(display: DisplayMode) {
        this.activeDisplay = display;
      }

      private updateOrdersCount(data: OrdersList) {
        this.nbOrdersToProcess = data.ordersToProcess.length;
        this.nbOrdersProcessed = data.ordersProcessed.length;
      }

      private updateProductsCount(data: OrderedProductsList) {
        this.nbProductsToProcess = data.productsToProcess.length;
        this.nbProductsProcessed = data.productsProcessed.length;
      }

      get nbItemsToProcess(): number {
        return this.activeDisplay === DisplayMode.ORDERS ? this.nbOrdersToProcess : this.nbProductsToProcess;
      }

      get nbItemsProcessed(): number {
        return this.activeDisplay === DisplayMode.ORDERS ? this.nbOrdersProcessed : this.nbProductsProcessed;
      }

      get isToProcessTabActive(): boolean {
        return this.activeTab === TabType.TO_PROCESS || this.activeTab === null;
      }

      get isProcessedTabActive(): boolean {
        return this.activeTab === TabType.PROCESSED;
      }

      get tabToProcess(): TabType {
        return TabType.TO_PROCESS
      }

      get tabProcessed(): TabType {
        return TabType.PROCESSED;
      }
      
    }

